import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CounselingService} from "../../counseling.service";
import {EmployeeService} from "../../../../services/employee.service";
import {ChildService} from "../../../../components/child/child.service";
import {MatTableDataSource} from "@angular/material/table";
import {AssessmentModel} from "../../../../interfaces/AssessmentModel";
import {Employee} from "../../../../interfaces/Employee";
import {ViewAssessmentComponent} from "../../components/view-assessment/view-assessment.component";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'app-counselling-assessment-report',
  templateUrl: './counselling-assessment-report.component.html',
  styleUrls: ['./counselling-assessment-report.component.scss']
})
export class CounsellingAssessmentReportComponent implements OnInit, OnDestroy {

  private _destroyed$ = new Subject<void>();
  // centreList$: Observable<Centre[]>;
  child$?: Observable<FullChild[]>;
  types = ["Admission Baseline Assessment", "Intermediate Assessment", "Discharge Assessment","Assessment 1","Assessment 2","Assessment 3","Assessment 4","Assessment 5","Assessment 6"]
  sessionType=''
  selectedCentre=''
  _centres$!: Observable<Centre[]>
  mAllData:any[]=[]
  mFilteredData:any[]=[]
  data:any
  dataSource!: MatTableDataSource<any>;
  employee: Observable<Employee[]>
  counselorName=''
  startDate?: Date | null
  endDate?: Date | null
  displayedColumns: string[] = ['childName', 'centreName', 'parentsName', 'conducted_by', 'dateOfAssessment', 'Action'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;


  constructor(private readonly centerService: CentreService,
              private readonly mFirestore: AngularFirestore,
              private _snackbar: MatSnackBar,
              private  counselingService: CounselingService,
              private centreService: CentreService,
              private readonly matDialog: MatDialog,
              private employeeService: EmployeeService,
              private readonly childService: ChildService) {
    this.dataSource = new MatTableDataSource<AssessmentModel>()
    this._centres$ = this.centreService.getAllCentres()
    this.employee = this.employeeService.getCounsellersFromUsers()

  }

  ngOnInit(): void {
    this.mFirestore.collection<AssessmentModel>('Assessments/allAssessments/assessments/').valueChanges({idField: 'id'}).pipe(takeUntil(this._destroyed$)).subscribe(res=> {
      // alert(res.length)z
      this.mAllData = res
      this.dataSource = new MatTableDataSource<AssessmentModel>(this.mAllData)
      this.dataSource.sort =this.sort
      this.dataSource.paginator =this.paginator
      // this.dataSource.data = this.mAllData

    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();

  }

  Search() {
    this.mFilteredData = this.mAllData
    console.log(this.mFilteredData)
    // if centre selected
// 100
    if(this.sessionType!=null && this.sessionType!=''){

      this.mFilteredData = this.mFilteredData.filter((x)=> x.type == this.sessionType)

    }

    if(this.selectedCentre!=null && this.selectedCentre!=''){

      this.mFilteredData = this.mFilteredData.filter((x)=> x.centreCode == this.selectedCentre)

    }
    if(this.startDate!=null){
      console.log('into startDate')

      this.mFilteredData =  this.mFilteredData.filter((x)=> x.dateOfAssessment.toDate()>=this.startDate!)
// 50
    }
    if(this.endDate!=null){


      // 50
      this.mFilteredData =  this.mFilteredData.filter((x)=> x.dateOfAssessment.toDate()<=this.endDate!)

    }


    if(this.counselorName!=null && this.counselorName!=''){
      this.mFilteredData = this.mFilteredData.filter((x)=> x.personConductingTest ==this.counselorName)

    }


    this.dataSource.data=this.mFilteredData
  }

  clearAll() {
    this.startDate = null
    this.endDate =null
    this.counselorName =''
    this.selectedCentre = ''
    this.types = []
    this.dataSource.data =this.mAllData
  }

  viewAssessment(element: AssessmentModel) {
    console.log(element)
    this.matDialog.open(ViewAssessmentComponent, {
      maxHeight: '800px',
      autoFocus: false,
      data: element
    })
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
